export enum InvoiceKeys {
  text,
  number,
  textarea
}

export enum InvoiceTypes {
  template = '1',
  file = '2'
}
